import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

/**
 * Export an array of plain objects (or array-of-arrays) to .xlsx
 */
export function exportExcel(rows, filename, sheetName = "تقرير") {
  if (!rows?.length) return;
  const worksheet = Array.isArray(rows[0])
    ? XLSX.utils.aoa_to_sheet(rows)
    : XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
  const safeName = String(filename || "report").replace(/[\\/:*?"<>|]/g, "-");
  XLSX.writeFile(workbook, `${safeName}.xlsx`);
}

/**
 * Capture a DOM section (RTL Arabic OK) into a multi-page PDF.
 */
export async function exportPdf(element, filename, options = {}) {
  if (!element) return;
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
  });
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF({
    orientation: options.orientation === "portrait" ? "portrait" : "landscape",
    unit: "mm",
    format: "a4",
  });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 8;
  const usableWidth = pageWidth - margin * 2;
  const imgHeight = (canvas.height * usableWidth) / canvas.width;
  let heightLeft = imgHeight;
  let position = margin;

  pdf.addImage(imgData, "PNG", margin, position, usableWidth, imgHeight);
  heightLeft -= pageHeight - margin * 2;

  while (heightLeft > 0) {
    position = margin - (imgHeight - heightLeft);
    pdf.addPage();
    pdf.addImage(imgData, "PNG", margin, position, usableWidth, imgHeight);
    heightLeft -= pageHeight - margin * 2;
  }

  const safeName = String(filename || "report").replace(/[\\/:*?"<>|]/g, "-");
  pdf.save(`${safeName}.pdf`);
}
